module.exports = __webpack_public_path__ + "img/read-inquiry.0f04429a.svg";